import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import styles from './PrimaryAppBar.css';
import { AppBar, Toolbar,  Typography, Link, Menu, Button, Popper, ClickAwayListener, MenuList, MenuItem } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import MyLink from './MyLink';

class PrimaryAppBar extends Component {
    
    constructor () {
        super();
        this.state = {
            menuToggled: false
        };

        this.setWrapperRef = this.setWrapperRef.bind(this);
    }

    
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.closeMenu();
        }
    }

    toggleMenu = () => {
        console.log(this.state)
        this.setState(
            prevState => ({
                menuToggled: !prevState.menuToggled
            })
        );
    }

    closeMenu = (event) => {
        if (this.anchorEl.contains(event.target)) {
            return;
        }
        this.setState({
            menuToggled: false
        });
    }

    render() {
        const {classes} = this.props;
        return (
            <div className={classes.PrimaryAppBar}>
                <AppBar 
                    color="inherit" 
                    classes={{root: classes.Appbar}}
                >
                    <Toolbar color="inherit" className={classes.toolbar}>
                        <div className={classes.centerTool}>
                            <div className={classes.leftToolbar} >
                            <Link href="/" underline="none">
                                <Typography variant="h4" classes={{root: classes.logo}}>
                                    nucle<b>AI</b>zer
                                </Typography>
                            </Link>
                                
                            </div>
                            <div className={classes.fill}>
                                <Typography variant="body1">
                                    We offer extended help for COVID-19 related research projects.
                                </Typography>
                            </div>
                            <nav className={classes.rightToolbar}>
                                <div className={classes.navWide}>
                                    <MyLink to='/'>Home</MyLink>
                                    <MyLink to='/method'>How it works</MyLink>
                                    <MyLink to='/gallery'>Gallery</MyLink>
                                    <MyLink to='/contact'>Contact</MyLink>
                                    <MyLink to='/download'>Download</MyLink>
                                    <MyLink to='/disclaimer'>Disclaimer</MyLink>
                                </div>
                                <div className={classes.navDropDown}>
                                    <Button
                                        onClick={this.toggleMenu}
                                        buttonRef={node => {
                                            this.anchorEl = node;
                                        }}
                                    >
                                        <MenuIcon></MenuIcon>
                                    </Button>
                                </div>
                                {/* <Popper open={this.state.menuToggled} anchorEl={this.anchorEl}> */}
                                    <ClickAwayListener onClickAway={this.closeMenu}>
                                        <div
                                        // ref={this.setWrapperRef}
                                            className={this.state.menuToggled ? classes.menuDropdownVisible : classes.menuDropdownInvisible}
                                            onClick={this.closeMenu}
                                        >
                                            <MyLink to='/'>Home</MyLink>
                                            <MyLink to='/method'>How it works</MyLink>
                                            <MyLink to='/gallery'>Gallery</MyLink>
                                            <MyLink to='/contact'>Contact</MyLink>
                                            <MyLink to='/download'>Download</MyLink>
                                            <MyLink to='/disclaimer'>Disclaimer</MyLink>
                                        </div>
                                    </ClickAwayListener>
                                {/* </Popper> */}
                                {/* <div
                                    ref={this.setWrapperRef}
                                    className={this.state.menuToggled ? classes.menuDropdownVisible : classes.menuDropdownInvisible}
                                    onClick={this.toggleMenu}
                                >
                                    <MyLink to='/'>Home</MyLink>
                                    <MyLink to='/method'>How it works</MyLink>
                                    <MyLink to='/gallery'>Gallery</MyLink>
                                    <MyLink to='/contact'>Contact</MyLink>
                                    <MyLink to='/disclaimer'>Disclaimer</MyLink>
                                </div> */}
                            </nav>
                        </div>
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}

export default withStyles(styles, {withTheme: true})(PrimaryAppBar);
